/* ============================================================
   BPB INTRO OVERLAY — assets/bpb-intro-overlay.js
   Anti-flash: el <html> ya tiene .bpb-intro-skip o
   .bpb-intro-active puesto por el inline script del Liquid
   antes de que este archivo se ejecute.
   ============================================================ */
(function () {
  'use strict';

  var STORAGE_KEY = 'bpb_intro_last_seen';
  var BAR_START   = 2700;
  var BAR_DUR     = 2800;
  var SCAN_DUR    = 1100;

  var root = document.getElementById('bpb-intro');
  if (!root) return;

  /* Si skip → el CSS ya lo oculta, no hay nada que hacer */
  if (document.documentElement.classList.contains('bpb-intro-skip')) return;

  var inEditor = !!(window.Shopify && window.Shopify.designMode);

  var scanLine  = root.querySelector('.bpb-intro__scan-line');
  var scanVeil  = root.querySelector('.bpb-intro__scan-veil');
  var logoWrap  = root.querySelector('.bpb-intro__hero');
  var glow      = root.querySelector('.bpb-intro__glow');
  var taglineEl = root.querySelector('.bpb-intro__tagline');
  var tLine     = root.querySelector('.bpb-intro__tagline-line');
  var barWrap   = root.querySelector('.bpb-intro__bar-wrap');
  var fill      = document.getElementById('bpbIntroFill');
  var door      = document.getElementById('bpbIntroDoor');
  var doorFrame = document.getElementById('bpbIntroFrame');
  var secured   = document.getElementById('bpbIntroSecured');
  var pctEl     = document.getElementById('bpbIntroPct');

  var raf = null;
  var timers = [];

  function clearAll() {
    if (raf) cancelAnimationFrame(raf);
    raf = null;
    timers.forEach(clearTimeout);
    timers = [];
  }

  /* Construir tagline char a char con JS para evitar problemas
     de encoding en Liquid con caracteres especiales           */
  function buildTagline() {
    var text = 'S\u00e9curit\u00e9 \u00b7 Qualit\u00e9 \u00b7 Excellence';
    taglineEl.innerHTML = '';
    taglineEl.style.opacity = '0';
    for (var i = 0; i < text.length; i++) {
      var ch = text[i];
      var s = document.createElement('span');
      s.className = 'bpb-intro__char';
      s.style.cssText = 'opacity:0;transform:translateY(7px);transition:opacity 0.3s ease,transform 0.3s ease;display:inline-block;';
      s.textContent = ch === ' ' ? '\u00a0' : ch;
      taglineEl.appendChild(s);
    }
  }

  function easeInOut(p) {
    if (p < 0.5) return 4 * p * p * p;
    return 1 - Math.pow(-2 * p + 2, 3) / 2;
  }

  function closeIntro() {
    if (!inEditor) {
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    }
    root.classList.add('bpb-intro--out');
    document.documentElement.style.overflow = '';
    document.documentElement.classList.remove('bpb-intro-active');
    setTimeout(function () {
      root.classList.add('bpb-intro--gone');
    }, 950);
  }

  function reset() {
    clearAll();
    scanLine.style.top     = '-2px';
    scanLine.style.opacity = '0';
    scanVeil.style.opacity = '1';
    logoWrap.style.transition = 'none';
    logoWrap.style.opacity    = '0';
    logoWrap.style.transform  = 'translateY(14px)';
    glow.style.transition = 'none';
    glow.style.opacity    = '0';
    tLine.style.transition = 'none';
    tLine.style.opacity    = '0';
    barWrap.style.transition = 'none';
    barWrap.style.opacity    = '0';
    barWrap.style.transform  = 'translateY(8px)';
    fill.style.width  = '0';
    door.style.left   = '0px';
    doorFrame.classList.remove('bpb-intro--locked');
    secured.style.color = 'rgba(255,255,255,0)';
    pctEl.textContent = '0';
    buildTagline();
  }

  function startAnim() {
    /* Scanner */
    var scanT0 = null;
    function scanTick(ts) {
      if (!scanT0) scanT0 = ts;
      var p = Math.min((ts - scanT0) / SCAN_DUR, 1);
      scanLine.style.top     = (-2 + p * (window.innerHeight + 4)) + 'px';
      var op = p < 0.05 ? p / 0.05 : p > 0.92 ? (1 - p) / 0.08 : 1;
      scanLine.style.opacity = String(op);
      scanVeil.style.opacity = String(Math.max(0, 1 - Math.max(0, (p - 0.7) / 0.3)));
      if (p < 1) requestAnimationFrame(scanTick);
    }
    requestAnimationFrame(scanTick);

    /* Logo fade+rise */
    timers.push(setTimeout(function () {
      logoWrap.style.transition = 'opacity 1s ease, transform 1s ease';
      logoWrap.style.opacity    = '1';
      logoWrap.style.transform  = 'translateY(0)';
    }, 1200));

    /* Glow */
    timers.push(setTimeout(function () {
      glow.style.transition = 'opacity 1s ease';
      glow.style.opacity    = '0.5';
    }, 2100));

    /* Tagline chars */
    timers.push(setTimeout(function () {
      taglineEl.style.opacity = '1';
      var chars = taglineEl.querySelectorAll('.bpb-intro__char');
      for (var i = 0; i < chars.length; i++) {
        (function (el, idx) {
          timers.push(setTimeout(function () {
            el.style.opacity   = '1';
            el.style.transform = 'translateY(0)';
          }, idx * 42));
        }(chars[i], i));
      }
    }, 1900));

    /* Línea */
    timers.push(setTimeout(function () {
      tLine.style.transition = 'opacity 0.7s ease';
      tLine.style.opacity    = '1';
    }, 3500));

    /* Barra + puerta */
    timers.push(setTimeout(function () {
      barWrap.style.transition = 'opacity 0.8s ease, transform 0.8s ease';
      barWrap.style.opacity    = '1';
      barWrap.style.transform  = 'translateY(0)';
      var scene   = door.parentElement;
      var maxLeft = scene.offsetWidth - door.offsetWidth - doorFrame.offsetWidth;
      var t0 = null;
      function tick(ts) {
        if (!t0) t0 = ts;
        var p = Math.min((ts - t0) / BAR_DUR, 1);
        var e = easeInOut(p);
        door.style.left    = (e * maxLeft) + 'px';
        fill.style.width   = (e * 100) + '%';
        pctEl.textContent  = String(Math.round(p * 100));
        if (p < 1) {
          raf = requestAnimationFrame(tick);
        } else {
          pctEl.textContent = '100';
        }
      }
      raf = requestAnimationFrame(tick);
    }, BAR_START));

    /* Encaje marco */
    timers.push(setTimeout(function () {
      doorFrame.classList.add('bpb-intro--locked');
      secured.style.transition = 'color 0.8s ease';
      secured.style.color      = 'rgba(255,255,255,0.5)';
    }, BAR_START + BAR_DUR + 60));

    /* Cierre automático */
    timers.push(setTimeout(closeIntro, BAR_START + BAR_DUR + 900));
  }

  function run() {
    reset();
    requestAnimationFrame(function () {
      requestAnimationFrame(startAnim);
    });
  }

  /* Re-init en editor Shopify */
  document.addEventListener('shopify:section:load', function (e) {
    if (!e.detail || !e.detail.sectionId) return;
    if (!root.closest('[id*="' + e.detail.sectionId + '"]')) return;
    root.classList.remove('bpb-intro--out', 'bpb-intro--gone');
    document.documentElement.classList.add('bpb-intro-active');
    document.documentElement.style.overflow = 'hidden';
    run();
  });

  run();

}());